import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class StopGroupSelectorViewModel extends SelectorBaseViewModel<StopGroup> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<StopGroup[]> {
        let result = await ServerConnection.callServer('/Complex/StopGroupServices/ListAllStopGroups', {})
        return result.StopGroups.map(x => {
            let s = new StopGroup(this);
            s.id = x.Id;
            s.title = `${x.Name} (${x.Code})`;
            return s;
        });
    }
}

export class StopGroup extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}